import {Component, OnInit} from '@angular/core';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {DialogModel} from '@shared/models/dialog.model';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {SnackBarService} from '@core/services/snack-bar.service';
import {PowerBiNodeField} from '@shared/models/power-bi-schema-designer.model';

export class FieldSelectionViewModel {
  title: string;
  fields: Field[];
  isExpanded: boolean;
}

export class Field {
  key: string;
  title: string;
  isChecked: boolean;
  isDisabled: boolean;
}

@Component({
    standalone: false,
    selector: 'app-select-fields-dialog',
  templateUrl: './select-fields-dialog.component.html',
  styleUrls: ['./select-fields-dialog.component.scss']
})
export class SelectFieldsDialogComponent implements OnInit, IDialogView {
  data: DialogModel;
  fieldSelectionViewModels: FieldSelectionViewModel[];
  private maximumSupportedFields = 75;

  constructor(private snackBarService: SnackBarService) { }

  ngOnInit(): void {
    this.fieldSelectionViewModels = this.data.input.fieldSelectionViewModels;
  }
  onOkClicked(): boolean {
    const selectedFieldKeys = {};
    this.fieldSelectionViewModels.forEach(viewModel => {
      const selections = [];
      for (let index = 0; index < viewModel.fields.length; index++) {
        if (viewModel.fields[index].isChecked) {
          selections.push(viewModel.fields[index].key);
        }
      }
      selectedFieldKeys[viewModel.title] = selections;
    });
    this.data.input.selectedFieldKeys = selectedFieldKeys;
    return true;
  }

  onToogleCheckBox($event: MatCheckboxChange, key: string, viewModelTitle: string) {
    const viewModel = this.fieldSelectionViewModels.find(o => o.title === viewModelTitle);
    const field = viewModel.fields.find(o => o.key === key);
    if ($event.checked) {
      if (this.canBeChecked(viewModel.fields)) {
        field.isChecked = $event.checked;
        return ;
      }
      $event.source.checked = false;
      this.showWarning();
      return ;
    }
    field.isChecked = false;
  }

  private canBeChecked(fields: Field[]): boolean {
    const checkedCount = this.checkedCount(fields);
    if (checkedCount >= this.maximumSupportedFields) {
      return false;
    }
    return true;
  }

  onSourceCheckBoxClicked($event: MatCheckboxChange, title: string) {
    const fields = this.getFields(title);
    if ($event.checked) {
      if (fields.length > this.maximumSupportedFields) {
        this.showWarning();
      }
      let checkCount = this.checkedCount(fields);
      for (let index = 0; index < fields.length; index++) {
        if (checkCount === this.maximumSupportedFields) {
          break;
        }
        if (fields[index].isChecked) {
          continue;
        }
        fields[index].isChecked = true;
        ++checkCount;
      }
    } else {
      for (let index = 0; index < fields.length; index++) {
        if (!fields[index].isDisabled) {
          fields[index].isChecked = false;
        }
      }
    }
  }

  private getFields(title: string): Field[] {
    const fieldSelectionViewModel = this.fieldSelectionViewModels.find(o => o.title === title);
    let fields: Field[] = [];
    if (fieldSelectionViewModel) {
      fields = fieldSelectionViewModel.fields;
    }
    return fields;
  }

  isAllSourceFieldSelected(title: string) {
    const fields = this.getFields(title);
    const checkedCount = this.checkedCount(fields);
    return checkedCount === fields.length;
  }

  private checkedCount(fields: Field[]) {
    let checkedCount = 0;
    for (let index = 0; index < fields.length; index++) {
      if (fields[index].isChecked) {
        checkedCount++;
      }
    }
    return checkedCount;
  }

  private showWarning() {
    this.snackBarService.showWarning(`Please note: You can select up to ${this.maximumSupportedFields} items to include for each data source.`);
  }

  isViewModelInInterminateState(title: string) {
    const fields = this.getFields(title);
    const checkedCount = this.checkedCount(fields);
    return checkedCount !== fields.length;
  }
}
